import { h, Component } from 'preact'
import cn from 'classnames'
import { iChat } from '../../types/chat'
import { iGroup } from '../../types/group'
import s from './ChatHeader.css'
import CircleButton from '../../UI/CircleButton'

interface iProps {
  data: iChat
  group?: iGroup
  isOnline: boolean
}

class ChatHeader extends Component<iProps> {
  get status () {
    const { isOnline, group, data } = this.props

    if (group) {
      return group.member_count
    }

    return isOnline
      ? 'online'
      : 'offline'
  }

  render () {
    const { data, isOnline } = this.props

    return (
      <div className={s.ChatHeader}>
        <div className={s.ChatHeader__info}>
          <div className={s.ChatHeader__avatar}>
            <img
              src=""
              alt=""
            />
          </div>

          <div>
            <div className={s.ChatHeader__title}>
              {data.title}
            </div>

            <div className={cn(s.ChatHeader__status, {
              [s.ChatHeader__status_gray]: !isOnline
            })}>
              {this.status}
            </div>
          </div>
        </div>

        <div className={s.ChatHeader__controls}>
          <CircleButton className={s.ChatHeader__control}>
            <i className={cn(s.ChatHeader__icon, s.ChatHeader__icon_search)}/>
          </CircleButton>
          <CircleButton className={s.ChatHeader__control}>
            <i className={cn(s.ChatHeader__icon, s.ChatHeader__icon_dots)}/>
          </CircleButton>
        </div>
      </div>
    )
  }
}

export default ChatHeader
